import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

const themes = {
  background: 'background',
  stretch: 'stretch'
};

const Image = ({
  alt,
  className,
  srcSet,
  src,
  width,
  height,
  theme,
  blendMode,
  isSvg,
  eagerLoad = false,
  sizes = '100vw',
  isLogo = false,
  isObjectFitContain = false
}) => {
  const image = (
    <img
      alt={alt ? alt : ''}
      className={cn(
        'image',
        { [`image--${theme}`]: theme },
        className,
        isObjectFitContain ? 'image--contain' : ''
      )}
      loading={eagerLoad ? 'eager' : 'lazy'}
      fetchPriority={eagerLoad ? 'high' : 'auto'}
      sizes={isLogo ? undefined : eagerLoad ? sizes : 'auto'}
      width={isLogo ? undefined : width > 0 ? width : null}
      height={isLogo ? undefined : height > 0 ? height : null}
      srcSet={srcSet}
      src={src}
      style={isLogo ? undefined : isSvg && width > 0 ? { width } : null}
    />
  );

  return theme === themes.background ? (
    <div
      className={cn('image__background-wrapper', {
        'image__background-wrapper--blend-mode': blendMode
      })}
    >
      {image}
    </div>
  ) : (
    image
  );
};

Image.propTypes = {
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  srcSet: PropTypes.string,
  src: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  theme: PropTypes.oneOf(Object.values(themes)),
  blendMode: PropTypes.bool,
  isSvg: PropTypes.bool,
  eagerLoad: PropTypes.bool,
  sizes: PropTypes.string,
  isLogo: PropTypes.bool,
  isObjectFitContain: PropTypes.bool
};

Image.propTypesMeta = {
  className: 'exclude',
  theme: 'exclude',
  blendMode: 'exclude',
  eagerLoad: 'exclude',
  sizes: 'exclude',
  isLogo: 'exclude'
};

Image.themes = themes;

export default Image;
